import type {FC, HTMLAttributes} from 'react'
import type React from 'react'
import {GrabberIcon, KebabHorizontalIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'

export interface DragAndDropProps extends HTMLAttributes<HTMLDivElement> {
  /** TODO */
}

/**
 * Initial thoughts:
 *
 *  1. We may want to specifically call this `DragAndDropContainer`
 *  2. Or name it specific to the `sort usecase` like `SortableList` -- unless we think in the future we can use props ton differentiate between resizing and grid
 */
const DragAndDropContainer: FC<React.PropsWithChildren<DragAndDropProps>> = ({children, ...props}) => {
  return (
    <div {...props}>
      Drag and Drop Container
      {children}
    </div>
  )
}

export interface DragAndDropItemProps extends HTMLAttributes<HTMLDivElement> {
  /** TODO */
}

/*
 * Also rename as `SortableItem`?
 *
 */
export const DragAndDropItem: FC<React.PropsWithChildren<DragAndDropProps>> = ({children, ...props}) => {
  return <div {...props}>{children}</div>
}

export interface DragAndDropTriggerProps extends HTMLAttributes<HTMLButtonElement> {
  /** TODO */
}

/*
 * The component that triggers dragging - most likely the 6 dots icon
 *
 */
export const DragAndDropTrigger: FC<React.PropsWithChildren<DragAndDropTriggerProps>> = () => {
  // allow for the button to be configurable
  return <IconButton aria-label={`Drag ${'TODO'}`} icon={GrabberIcon} />
}

export interface DragAndDropContextMenuProps extends HTMLAttributes<HTMLButtonElement> {
  /** TODO */
}

/*
 * The contentMenu component... this will likely need allow children passed in incase the user has more content menu items
 *
 */
export const DragAndDropContextMenu: FC<React.PropsWithChildren<DragAndDropContextMenuProps>> = () => {
  // allow for the button to be configurable
  return <IconButton aria-label={`Drag ${'TODO'}`} icon={KebabHorizontalIcon} />
}

export const DragAndDrop = Object.assign(DragAndDropContainer, {
  ContextMenu: DragAndDropContextMenu,
  Item: DragAndDropItem,
  Trigger: DragAndDropTrigger,
})

try{ DragAndDropContainer.displayName ||= 'DragAndDropContainer' } catch {}
try{ DragAndDropItem.displayName ||= 'DragAndDropItem' } catch {}
try{ DragAndDropTrigger.displayName ||= 'DragAndDropTrigger' } catch {}
try{ DragAndDropContextMenu.displayName ||= 'DragAndDropContextMenu' } catch {}
try{ DragAndDrop.displayName ||= 'DragAndDrop' } catch {}